import { UtenteLogged } from "../authentication/authenticationSlice";

export const userIsLogged = (utente: UtenteLogged) => {
  // let isLogged = false;
  // Object.keys(utente).length !== 0 && (utente.isLogged = true);
  return utente.isLogged;
};
